

export function formatPrice(price) {
	let convertedPrice = 0;
	convertedPrice = parseInt(price);

	if(!isNaN(convertedPrice)) {
		price = `P ${(price/1).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
	}

  	return price;
}

export function formatQuantity(quantity) {
	let convertedPrice = 0;
	convertedPrice = parseInt(quantity);

	if(!isNaN(convertedPrice)) {
		quantity = `${(quantity/1).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
	}

  	return quantity;
}




// WEBPACK FOOTER //
// ./src/helpers/helpers.js